import React from "react";
import { Container, Row, Col } from "reactstrap";

function TextGrid() {
  let pageHeader = React.createRef();
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;
  return (
    <>
      <div
        style={{
          backgroundColor: "#fff",
          background: `url(${require("assets/images/landscape.webp")})`,
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
          backgroundPosition: "center",
          backgroundSize: "cover",
          paddingTop: "8rem",
          overflow: "hidden",
        }}
        className="section pt-5"
        data-parallax={true}
        ref={pageHeader}
      >
        <div className="overlay-primary"></div>
        <Container>
          <Row className="justify-content-center">
            <Col md={9}>
              <h1
                className="m-0 my-4 text-g-p text-white"
                style={{
                  fontSize: size ? "3rem" : "2rem",
                }}
              >
                Event
                <br />
                Summary
              </h1>
              <p className="text-400 text-white">
                The UK is entering a new era of digital transformation, where Digital Twins are
                becoming essential for creating more resilient infrastructure, smarter cities, and
                sustainable industries. Initiatives such as the{" "}
                <b>DIATOMIC Project</b>, which is developing trusted data-sharing and
                interoperability frameworks for industrial digital twins, are helping establish the
                foundations for connected digital ecosystems across the UK. As government,
                infrastructure owners, and industry accelerate adoption, the{" "}
                <b>4th Annual UK DIGITAL TWIN 2026</b> provides the premier platform for leaders to
                exchange insights, showcase innovation, and shape the future of connected digital
                infrastructure.
                <br />
                <br />
                Building on the success of the previous three editions—held in London (twice) and
                Nottingham last year—this year&apos;s conference comes to{" "}
                <b>Birmingham</b> - one of the UK&apos;s fastest-growing centres for digital
                innovation, smart infrastructure, and urban transformation. The event will gather
                public sector leaders, city authorities, infrastructure owners, developers,
                engineers, utilities, transport operators, technology innovators, and academia to
                accelerate the adoption of Digital Twin technologies across the region.
                <br />
                <br />
                Supported by <b>Birmingham City Council</b> and <b>Digital Birmingham</b>, the
                conference on <b>November 11</b> will showcase pioneering projects, practical
                implementation strategies, and emerging innovations that are redefining smart
                cities, urban planning, transportation, energy systems, and the built environment.
                More importantly, it provides a collaborative forum where policy makers, industry
                leaders, and technology providers can exchange ideas, address common challenges, and
                shape the future of intelligent, sustainable, and resilient cities.
                <br />
                <br />
                Whether you are developing next-generation infrastructure, modernising critical
                assets, or driving digital transformation within your organisation,{" "}
                <b>UK DIGITAL TWIN 2026</b> offers an unparalleled opportunity to learn from
                industry pioneers, discover cutting-edge solutions, build strategic partnerships,
                and contribute to the national dialogue on the future of Digital Twins in the UK.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default TextGrid;
